<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 md12>
        <cpnTransactionHeader
          :transaction_id="transaction_id"
          v-if="!this.$apollo.loading"
        ></cpnTransactionHeader>
      </v-flex>
      <v-flex xs12 md4>
        <cpnTimeline
          :transaction_id="transaction_id"
          v-if="!this.$apollo.loading"
        ></cpnTimeline>
      </v-flex>
      <v-flex xs12 md8>
        <cpnPurchaseDetails v-if="!this.$apollo.loading"></cpnPurchaseDetails>
        <cpnReceivers v-if="!this.$apollo.loading"></cpnReceivers>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import TransactionHeader from "../components/transaction/TransactionHeader";
import Timeline from "../components/transaction/Timeline";
import PurchaseDetails from "../components/transaction/PurchaseDetails";
import Receivers from "../components/transaction/Receivers";

// import { EventBus } from '../utils/event-bus'

export default {
  data: function () {
    return {
      transaction: {},
      transaction_id: "",
      loading: false,
    };
  },
  components: {
    cpnTransactionHeader: TransactionHeader,
    cpnTimeline: Timeline,
    cpnPurchaseDetails: PurchaseDetails,
    cpnReceivers: Receivers,
  },
  created() {
    if (this.$route.params.id) {
      this.transaction_id = this.$route.params.id;
    }
    //   EventBus.$on('competenceSelected', competence => {
    //       // this.competence = competence

    //   })
  },
  // apollo: {
  //     powerplants: {
  //         query: GET_POWERPLANTCOMBO,
  //         // Optional result hook
  //         result ({ data, loading }) {
  //             this.power_plants = data.powerplants
  //             this.loading = loading
  //         },
  //         // Error handling
  //         error (error) {
  //             console.error('We\'ve got an error!', error)
  //         },
  //     }
  // }
};
</script>
